module.exports = __webpack_public_path__ + "img/how_to_print_chrome_en.d72a29f9.png";